import SpinnerLoader from "./SpinnerLoader";
export default SpinnerLoader;
